import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@airbus/components-react/components/Modal'
import Button from '@airbus/components-react/components/Button'
import LightDarkContext from 'context/LightDarkModeContext'
import { Inline, Stack, Typography } from '@airbus/components-react/components'

type Props = {
  isOpened: boolean
  onCloseModal: () => void
  onSubmit: () => void
  confirmMessage: string
}

const styleModal = {
  position: 'absolute',
  transform: 'translate(35%, 50%)',
  width: '60%',
  height: 'fit-content',
  border: '2px solid #000',
  boxShadow: 24,
  overflowY: 'scroll',
  scrollbarWidth: 'none',

  '& > .text': {
    fontWeight: 'fontWeightBold',
    width: '-webkit-fill-available',
    paddingTop: '2em',
    paddingBottom: '1em',
    paddingLeft: '1em',
  },
}

const ModalConfirm = ({ isOpened, onCloseModal, onSubmit, confirmMessage }: Props) => {
  const { t } = useTranslation()

  const { getBackgroundColor } = useContext(LightDarkContext)

  return (
    <Modal
      open={isOpened}
      onClose={onCloseModal}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Stack
        spacing='1-x'
        align='center'
        style={{ ...styleModal, backgroundColor: getBackgroundColor(), padding: '15px' }}
      >
        <Typography variant='large'>{confirmMessage}</Typography>

        <Inline spacing='4-x'>
          <Button variant='secondary' onClick={onCloseModal}>
            {t('7000414')}
          </Button>
          <Button variant='primary' onClick={onSubmit}>
            {t('7000419')}
          </Button>
        </Inline>
      </Stack>
    </Modal>
  )
}

export default ModalConfirm
